import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/menus/menuTaxonomyCategoryList';
import MenuTaxonomyCategoryListItem from '@/components/menus/MenuTaxonomyCategoryListItem';
import { IMenuTaxonomy } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  title: string;
  taxonomyList: IMenuTaxonomy[];
};

const MenuTaxonomyCategoryList: React.FC<ComponentProps> = ({ title, taxonomyList }) => {
  const classes = useStyles();

  if (taxonomyList.length === 0) return null;
  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <h3 className={classes.title}>{title}</h3>
        <GridContainer>
          {taxonomyList.map((item, index) => {
            return (
              <MenuTaxonomyCategoryListItem
                taxonomy={item}
                key={`taxonomy-item-${index.toString()}`}
              />
            );
          })}
        </GridContainer>
      </div>
    </div>
  );
};

export default MenuTaxonomyCategoryList;
